import { CountryCode } from "libphonenumber-js";
import { FileReference, OrgSettings, PaymentSettings } from "./baseEntities";
import { OrderType } from "./orderEntities";
import { ActiveTable } from "./tableEntities";
import { PaymentType } from "./paymentEntities";
import { OpeningHour } from "./openingHoursEntities";
import { DomainSetting } from "./domainSettingEntities";

export interface ServiceAvailability {
  orderTypeCode: string;
  available: boolean;
  appliesUntil: string | null;
  reasonCode: string | null;
}

export interface ServiceSettings {
  orderTypeCode: string;
  settings: Settings;
}

export interface Settings {
  allowGuestCheckout: boolean;
  allowNoCustomerDetails: boolean;
}

export interface OrgSites {
  id: string;
  orgName: string;
  domainSettings: DomainSetting;
  settings: OrgSettings;
  sites: SiteListObject[];
  useComoAuth: boolean;
}

export interface SiteListObject {
  id: string;
  name: string;
  image: FileReference | null;
  branding: SiteBranding | null;
  address: Address;
  serviceAvailability: ServiceAvailability[];
  serviceSettings: ServiceSettings[];
  openingTimes: OpeningHour[];
  timeZone: string;
  orderTypes: OrderType[];
}
export interface SiteBranding {
  onlineOrdering: {
    sideBarLogo: FileReference | null;
    sitePickerLogo: FileReference | null;
  };
  kioskLogo: FileReference | null;
  posLogo: FileReference | null;
  integrationData: Record<string, FileReference | null>;
}

export interface Site {
  id: string;
  siteName: string;
  siteImage: FileReference | null;
  branding: SiteBranding | null;
  siteAddress: Address;
  paymentMethods: ResPaymentMethod[];
  uplistaGroupId: string;
  tableOrderingAllowPayAtTable: boolean;
  availability: SiteAvailability[];
  serviceAvailability: ServiceAvailability[];
  orderTypes: OrderType[];
  activeTables: ActiveTable[];
  ///////
  taxAggregationMethod: TaxAggMethod;
  taxRoundingMethod: RoundingMethod;
  pricesIncludeTax: boolean;
  countryCode: CountryCode;
  onBehalfOf: string;
  timeZone: string;
  serviceSettings: ServiceSettings[];
  openingTimes: OpeningHour[];
  paymentSettings: PaymentSettings;
}

export enum TaxAggMethod {
  PER_TAX = "PER_TAX",
  PER_LINE = "PER_LINE",
  PER_UNIT = "PER_UNIT",
}

export enum RoundingMethod {
  HALF_UP = "HALF_UP",
  HALF_EVEN = "HALF_EVEN",
  ROUND_UP = "ROUND_UP",
  ROUND_DOWN = "ROUND_DOWN",
}

export interface ResPaymentMethod {
  id: string;
  name: string;
  paymentType: PaymentType;
  surchargeApplies: boolean;
}

export interface TimeOfDay {
  hour: number;
  minute: number;
}

export interface DaysOfWeek {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export interface SiteAvailability {
  applies: DaysOfWeek;
  startsAt: TimeOfDay;
  endsAt: TimeOfDay;
}

export interface Address {
  address1: string;
  address2: string;
  city: string;
  countryId: string | null;
  postalCode: string;
  state: string;
  latitude: number | null;
  longitude: number | null;
}
